export default  {
  bindings: {
    users: '<'
  },
  controller: 'userListController',
  template: require('../views/user.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/components/user.list.component.js